export function organizationCode(name) {
  const value = name.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
  if (!value) return '';
  return (/^[a-z]/.test(value) && value.length >= 3 ? value : `org-${value}`).slice(0, 40);
}

export function generatePassword() {
  const bytes = crypto.getRandomValues(new Uint8Array(18));
  return 'A!' + btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_');
}

export const signInPath = org => `/login?organization=${encodeURIComponent(org.slug)}`;

export function welcomeMessage(org, password, origin = window.location.origin, passwordChanged = false) {
  return `Welcome to ${org.name}!

${passwordChanged ? 'Your organization admin password has been updated.' : 'Your Affiliate Dashboard is ready.'}${org.active === false ? '\nSign-in is currently paused. Contact your administrator to reactivate this organization.' : ''}

Sign-in link: ${origin}${signInPath(org)}
Username: ${org.adminUsername}
Password: ${password || 'Use the password already shared with you.'}

Getting started:
1. Open your organization sign-in link and sign in with the details above.
2. In Settings → Connections, connect your Business Managers and ad accounts.
3. Open Affiliates to create affiliate logins and assign their ad accounts. Share this same organization sign-in link with your affiliates, along with their own credentials.
4. Use the theme selector to choose Classic, Console, or Jarvis.

Keep these sign-in details private. If you need help, contact the person who invited you.`;
}

export async function copyText(value) {
  if (navigator.clipboard?.writeText) return navigator.clipboard.writeText(value);
  const input = document.createElement('textarea');
  input.value = value;
  input.style.cssText = 'position:fixed;opacity:0';
  document.body.appendChild(input);
  try { input.select(); if (!document.execCommand('copy')) throw Error('Copy unavailable'); }
  finally { input.remove(); }
}
